import { AlgoliaIndice, type ProductHit, type CategoryHit } from '../types';
import { getSearchIndex } from './getSearchIndex';
import { logger } from '@libs/core';

export const getCategoriesByCustomNames = async (
    productHit: ProductHit,
    currentTime?: number
): Promise<CategoryHit[]> => {
    try {
        const index = getSearchIndex(AlgoliaIndice.CATEGORIES);
        let filters =
            productHit.custom_category_names
                ?.map((cateogryName: string) => `custom_category_name:"${cateogryName.toLocaleLowerCase()}"`)
                .join(' OR ') ?? '';

        if (currentTime) {
            filters += ` AND (startDate < ${currentTime} AND endDate > ${currentTime})`;
        }

        const response = await index.search<CategoryHit>('', {
            filters,
        });

        if (response.hits?.length) {
            return response.hits;
        }

        return [];
    } catch (error) {
        console.error(
            '[algolia/getCategoriesByCustomNames]',
            { index: AlgoliaIndice.CATEGORIES },
            JSON.stringify(error)
        );

        return [];
    }
};

export const getCategoryTimeframeByPath = async (
    categoryPath: string,
    currentTime?: number
): Promise<CategoryHit[]> => {
    try {
        const index = getSearchIndex(AlgoliaIndice.CATEGORIES);

        let filters = `normalized_custom_category_name:"${categoryPath.toLocaleLowerCase()}"`;

        if (currentTime) {
            filters += ` AND (startDate < ${currentTime} AND endDate > ${currentTime})`;
        }

        const response = await index.search<CategoryHit>('', {
            filters,
        });

        if (response.hits?.length) {
            return response.hits;
        }

        return [];
    } catch (error) {
        logger.error(
            '[algolia/getCategoriesByCustomNames]',
            { index: AlgoliaIndice.CATEGORIES },
            JSON.stringify(error)
        );

        return [];
    }
};
